import { Stack } from "expo-router";
import React from "react";

export default function MyMemoriesLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "My Memories" }} />
      <Stack.Screen name="[id]" options={{ title: "Edit Memory" }} />
      <Stack.Screen name="new" options={{ title: "New Memory" }} />
      <Stack.Screen name="visualiser" options={{ title: "Visualiser" }} />
    </Stack>
  );
}
